import script from "./TaskInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskInfo.vue?vue&type=script&lang=ts&setup=true"

import "./TaskInfo.vue?vue&type=style&index=0&id=e70a1f1c&lang=less"

const __exports__ = script;

export default __exports__